var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex gap-1.5 items-center justify-start"},[_c('ZIcon',{attrs:{"icon":_vm.icon,"size":"x-small.5","color":_vm.iconColor}}),_vm._v(" "),_c('span',{staticClass:"text-xs text-gray-500"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }